type LogLevel = 'debug' | 'info' | 'warn' | 'error'

type LogContext = Record<string, unknown> | undefined

const isProduction = process.env.NODE_ENV === 'production'

const emitLog = (level: LogLevel, message: string, context?: LogContext): void => {
  if (level === 'debug' && isProduction) {
    return
  }

  const payload = {
    message,
    ...context,
  }

  switch (level) {
    case 'debug': {
      console.debug(payload)
      return
    }
    case 'info': {
      console.info(payload)
      return
    }
    case 'warn': {
      console.warn(payload)
      return
    }
    case 'error': {
      console.error(payload)
    }
  }
}

export const webLogger = {
  debug(message: string, context?: LogContext): void {
    emitLog('debug', message, context)
  },
  info(message: string, context?: LogContext): void {
    emitLog('info', message, context)
  },
  warn(message: string, context?: LogContext): void {
    emitLog('warn', message, context)
  },
  error(message: string, context?: LogContext): void {
    emitLog('error', message, context)
  },
}
